(function (ws) {
    'use strict';

    ws.views.quoteLockedModalView = ws.views.modal.extend({

        /**
         * Initialize
         */
        initialize: function() {
            ws.views.modal.prototype.initialize.call(this);
            this.template = _.template(this.$('#quote-locked-content').html());
            this.quoteId = $('#quoteCode').val();
        },

        /**
         * On Modal Open
         */
        onOpen: function(data) {
            if (this.isAlreadyOpen()) {
                console.debug('Modal ID: ' + this.modalId + ' is already opened.');
                return;
            }

            //check if the modal is being opened by API REST update with data response
            if (data && ![true, 'true'].includes($('#isSessionQuoteCreationInProgress').val())) {
                data.quote = this.quoteId;
                this.$el.find('.modal-body p').html(this.template(data));
            } else if ([true, 'true'].includes($('#isSessionQuoteCreationInProgress').val())) {
                window.sessionQuoteCreationModalTriggered = true;
            }

            this.trigger('onOpen');
            this.render();
        }

    });
}(westcon));
